var e = /* @__PURE__ */ ((r) => (r.loading = "loading", r.fetchMore = "fetchMore", r.ready = "ready", r.error = "error", r))(e || {});
function n(r) {
  return [
    "loading",
    "fetchMore"
    /* fetchMore */
  ].includes(
    r
  );
}
export {
  e as NetworkStatus,
  n as isRequestInFlight
};
